import { db } from "./db.js";
import { ref } from "vue";

// ==================== CREATE ====================

function addDocketTask(firmId, data) {
  const ref1 = db.collection(`firms/${firmId}/additions/tm-addition/trademark-tasks/`).doc();
  data.id = ref1.id;
  return ref1.set(data).catch( error => { console.log("Error in addDocketTask " + error); });
}

// ==================== READ ====================

function streamDocketing(firmId, onSnap) {
  return db.collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .orderBy("deadline")
    .onSnapshot(onSnap, (error) => { console.log(error); });
}

async function getDocketTasksByDeadline(firmId) {
    const tasks = ref([]);
    await db.collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .orderBy("deadline")
    .get()
    .then((querySnapshot) => {
        tasks.value = querySnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });
      });
    return tasks;
}

async function getDocketTasksByTrademarkSerialNumberByDeadline(firmId, serialNumber) {
    const tasks = ref([]);
    await db
    .collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .where("serialNumber", "==", serialNumber)
    .orderBy("deadline")
    .get()
    .then((querySnaptshot) => {
      tasks.value = querySnaptshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
    return tasks;
}

async function getDocketTasksByTrademarkSerialNumberByStatus(firmId, serialNumber) {
    const tasks = ref([]);
    await db
    .collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .where("serialNumber", "==", serialNumber)
    .orderBy("status")
    .get()
    .then((querySnaptshot) => {
      tasks.value = querySnaptshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
    return tasks;
}

async function getDocketTasksByStatus(firmId) {
    const tasks = ref([]);
    db.collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .orderBy("status", "asc")
    .get()
    .then((querySnapshot) => {
        tasks.value = querySnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });
      });
    return tasks;
}

async function getDocketTask(firmId, taskId) {
    const task = await db.doc(`firms/${firmId}/additions/tm-addition/trademark-tasks/${taskId}`).get();
    return task.exists ? task.data() : null;
}

async function getPendingDocketTasks(firmId) {
    const tasks = ref([]);
    await db.collection(`firms/${firmId}/additions/tm-addition/trademark-tasks`)
    .where("status", "!=", "Completed")
    .get()
    .then((querySnapshot) => {
        tasks.value = querySnapshot.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });
      });
    return tasks;
}

// ==================== UPDATE ====================

function updateDocketTask(firmId, taskId, data) {
  return db.doc(`firms/${firmId}/additions/tm-addition/trademark-tasks/${taskId}`).update(data);
}

// ==================== NO DELETE ALLOWED ====================

export {
  addDocketTask,
  getDocketTask,
  getDocketTasksByDeadline,
  getDocketTasksByStatus,
  getDocketTasksByTrademarkSerialNumberByDeadline,
  getDocketTasksByTrademarkSerialNumberByStatus,
  getPendingDocketTasks,
  streamDocketing,
  updateDocketTask,
};
